import { render } from "./questioneditorledord.vue?vue&type=template&id=c36c85dc"
import script from "./questioneditorledord.vue?vue&type=script&lang=js"
export * from "./questioneditorledord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__